package com.hyperether.goodjob.database.composeApp

import app.cash.sqldelight.SuspendingTransacterImpl
import app.cash.sqldelight.db.AfterVersion
import app.cash.sqldelight.db.QueryResult
import app.cash.sqldelight.db.SqlDriver
import app.cash.sqldelight.db.SqlSchema
import com.hyperether.goodjob.database.AppDatabase
import com.hyperether.goodjob.database.AppDatabaseQueries
import kotlin.Long
import kotlin.Unit
import kotlin.reflect.KClass

internal val KClass<AppDatabase>.schema: SqlSchema<QueryResult.AsyncValue<Unit>>
  get() = AppDatabaseImpl.Schema

internal fun KClass<AppDatabase>.newInstance(driver: SqlDriver): AppDatabase =
    AppDatabaseImpl(driver)

private class AppDatabaseImpl(
  driver: SqlDriver,
) : SuspendingTransacterImpl(driver),
    AppDatabase {
  override val appDatabaseQueries: AppDatabaseQueries = AppDatabaseQueries(driver)

  public object Schema : SqlSchema<QueryResult.AsyncValue<Unit>> {
    override val version: Long
      get() = 29

    override fun create(driver: SqlDriver): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS Workspace (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    _id TEXT UNIQUE,
          |    name TEXT,
          |    type TEXT,
          |    user_id TEXT,
          |    plan TEXT,
          |    workspaceType TEXT,
          |    lastAccessed TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS User (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    _id TEXT,
          |    fullName TEXT,
          |    email TEXT,
          |    password TEXT,
          |    confirmStatus TEXT,
          |    role TEXT,
          |    workspace_ids TEXT,
          |    planId TEXT,
          |    phone TEXT,
          |    city TEXT,
          |    contry TEXT,
          |    zip TEXT,
          |    address TEXT,
          |    status TEXT,
          |    skills TEXT,
          |    teams TEXT,
          |    customerId TEXT,
          |    upcomingLeave TEXT,
          |    workingHours TEXT,
          |    pendingPlanId TEXT,
          |    subscriptionEndsAt TEXT,
          |    lang TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS Plan (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    _id TEXT UNIQUE,
          |    name TEXT,
          |    price REAL,
          |    perMonth REAL,
          |    description TEXT,
          |    storage TEXT,
          |    planSupport TEXT,
          |    limitUsers INTEGER,
          |    limitManagers INTEGER,
          |    isPopular INTEGER,
          |    currency TEXT,
          |    interval TEXT,
          |    stripeProductId TEXT,
          |    stripePriceId TEXT,
          |    type TEXT,
          |    descriptions TEXT,
          |    names TEXT,
          |    storages TEXT,
          |    planSupports TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS Job (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    _id TEXT,
          |    jobTitle TEXT,
          |    status TEXT,
          |    assignees TEXT,
          |    creatorId TEXT,
          |    workspaceId TEXT,
          |    start_at TEXT,
          |    end_at TEXT,
          |    repeat TEXT,
          |    repeatInterval TEXT,
          |    startDate TEXT,
          |    dueDate TEXT,
          |    jobDuration INTEGER,
          |    steps TEXT,
          |    userId TEXT,
          |    contactId TEXT,
          |    contactSiteName TEXT,
          |    contactParentId TEXT,
          |    notes TEXT,
          |    fileObjects TEXT,
          |    completionReport TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS Contact (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    _id TEXT,
          |    name TEXT,
          |    contactType TEXT,
          |    industry TEXT,
          |    address TEXT,
          |    email TEXT,
          |    phone TEXT,
          |    personName TEXT,
          |    personEmail TEXT,
          |    personAddress TEXT,
          |    personPhone TEXT,
          |    workspaceId TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS Site (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    _id TEXT,
          |    personName TEXT,
          |    personAddress TEXT,
          |    personPhone TEXT,
          |    siteName TEXT,
          |    parentId TEXT,
          |    parentName TEXT,
          |    personEmail TEXT,
          |    workspaceId TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS Team (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    _id TEXT,
          |    name TEXT,
          |    workspaceId TEXT,
          |    employees TEXT,
          |    type TEXT,
          |    createdAt TEXT,
          |    updatedAt TEXT
          |)
          """.trimMargin(), 0).await()
      driver.execute(null, """
          |CREATE TABLE IF NOT EXISTS Skills (
          |    id INTEGER PRIMARY KEY AUTOINCREMENT,
          |    _id TEXT,
          |    name TEXT,
          |    workspaceId TEXT
          |)
          """.trimMargin(), 0).await()
    }

    private fun migrateInternal(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      if (oldVersion <= 1 && newVersion > 1) {
      }
      if (oldVersion <= 2 && newVersion > 2) {
      }
      if (oldVersion <= 3 && newVersion > 3) {
      }
      if (oldVersion <= 4 && newVersion > 4) {
      }
      if (oldVersion <= 5 && newVersion > 5) {
      }
      if (oldVersion <= 6 && newVersion > 6) {
      }
      if (oldVersion <= 7 && newVersion > 7) {
      }
      if (oldVersion <= 8 && newVersion > 8) {
      }
      if (oldVersion <= 9 && newVersion > 9) {
      }
      if (oldVersion <= 10 && newVersion > 10) {
      }
      if (oldVersion <= 11 && newVersion > 11) {
      }
      if (oldVersion <= 12 && newVersion > 12) {
      }
      if (oldVersion <= 13 && newVersion > 13) {
      }
      if (oldVersion <= 14 && newVersion > 14) {
      }
      if (oldVersion <= 15 && newVersion > 15) {
      }
      if (oldVersion <= 16 && newVersion > 16) {
      }
      if (oldVersion <= 17 && newVersion > 17) {
      }
      if (oldVersion <= 18 && newVersion > 18) {
      }
      if (oldVersion <= 19 && newVersion > 19) {
      }
      if (oldVersion <= 20 && newVersion > 20) {
      }
      if (oldVersion <= 21 && newVersion > 21) {
      }
      if (oldVersion <= 22 && newVersion > 22) {
      }
      if (oldVersion <= 23 && newVersion > 23) {
      }
      if (oldVersion <= 24 && newVersion > 24) {
      }
      if (oldVersion <= 25 && newVersion > 25) {
      }
      if (oldVersion <= 26 && newVersion > 26) {
      }
      if (oldVersion <= 27 && newVersion > 27) {
      }
      if (oldVersion <= 28 && newVersion > 28) {
      }
    }

    override fun migrate(
      driver: SqlDriver,
      oldVersion: Long,
      newVersion: Long,
      vararg callbacks: AfterVersion,
    ): QueryResult.AsyncValue<Unit> = QueryResult.AsyncValue {
      var lastVersion = oldVersion

      callbacks.filter { it.afterVersion in oldVersion until newVersion }
      .sortedBy { it.afterVersion }
      .forEach { callback ->
        migrateInternal(driver, oldVersion = lastVersion, newVersion = callback.afterVersion +
          1).await()
        callback.block(driver)
        lastVersion = callback.afterVersion + 1
      }

      if (lastVersion < newVersion) {
        migrateInternal(driver, lastVersion, newVersion).await()
      }
    }
  }
}
